import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { Switch } from "../components/ui/switch";

const SettingsModal = ({ isOpen, onClose, hardMode, setHardMode, streak, club }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="glass border-white/10 max-w-sm" data-testid="settings-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-gold text-center">
            Settings
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          {/* Hard Mode Toggle */}
          <div className="flex items-center justify-between">
            <div>
              <p className="text-text-primary font-body font-medium">Hard Mode</p>
              <p className="text-text-muted text-xs font-body">
                No hints available in hard mode
              </p>
            </div>
            <Switch
              checked={hardMode}
              onCheckedChange={setHardMode}
              data-testid="hard-mode-toggle"
            />
          </div>
          
          <div className="border-t border-white/10" />
          
          {/* Stats */}
          <div className="space-y-3">
            <h3 className="text-text-primary font-body font-medium">Your Stats</h3>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="glass rounded-lg p-3 text-center">
                <p className="text-2xl font-display font-bold text-gold">{streak}</p>
                <p className="text-xs text-text-muted font-body">Current Streak</p>
              </div>
              
              <div className="glass rounded-lg p-3 text-center">
                <p className="text-2xl font-display font-bold text-text-primary">
                  {club || "—"}
                </p>
                <p className="text-xs text-text-muted font-body">Club</p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-white/10" />
          
          {/* About */}
          <div className="text-center">
            <p className="text-text-muted text-xs font-body">
              GuessTheBolly v1.0<br />
              A daily Bollywood movie guessing game
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsModal;
